import kformUtils from '../utils/kform-utils';

const kformElementDirective = /* @ngInject */ (
	/** @type {import('angular').ICompileService} */ $compile,
) => ({
	scope: false,
	link:  (/** @type {any} */ scope, /** @type {any} */ element) => {
		scope.isDescriptionHTML = () => {
			return (scope.component.description?.startsWith('<'));
		}
		element.replaceWith($compile(kformUtils.fieldWrap(scope.template))(scope));
		scope.$emit('formElementRender', element);
	},
});

export default kformElementDirective;
